import { CRUISE_SORT } from 'components/SearchPage/Constants';
import { ANY, TRACKING_ACTION } from 'contexts/AnalyticsContext/Constants';
import { BRAND_RCI } from 'contexts/CruiseSearchContext/constants';
import { EMPTY_CRUISE_RECOMMENDATION_ID } from 'contexts/PersonalizationContext/constants';
import { trackEvent, trackPage } from '../ui-analytics';
import { getCruiseSearchType, getFormatPromoDashboard, getNumberGuest, getSearchMonths } from '../utils';

export function trackOnLoadCruiseSearch({
	search,
	locale: { country, language, currency },
	results,
	pagination,
	perks,
	brand,
	sort = [],
	trackingAction = TRACKING_ACTION.INIT,
	query = {},
	labelsSort,
	splitEx,
	isAuthenticated,
}) {
	const { destination, departurePort, nights, children, adults, ship } = search;

	const [sortInfo, by = ''] = sort || [];
	const labelEvent = labelsSort[`${sortInfo}${by}`];
	const searchOption = labelEvent ? `${CRUISE_SORT}: ${labelEvent}` : undefined;

	const cruiseSearchType = getCruiseSearchType(search, query);

	const onLoadCruiseSearchEvent = {
		brand: brand.alpha3Code.toUpperCase(),
		cruiseSearchType,
		cardPosition: results?.cruises?.map((_, i) => i + 1),
		country,
		consumer_id: '',
		cruiseRecommendationId: results?.cruiseRecommendationId || EMPTY_CRUISE_RECOMMENDATION_ID,
		cruiseSearchFilter: window?.location?.search ? window?.location?.search?.replace('?search=', '') : ANY,
		cruiseSearchGuestsChildren: children ? children[0] : ANY,
		cruiseSearchNumberOfGuests: getNumberGuest(adults, children),
		currency,
		eventType: trackingAction === TRACKING_ACTION.SEARCH_UPDATE ? 'searchOptionChange' : '',
		groupId: results?.cruises?.length ? results?.cruises?.map((cruise) => cruise.lowestPriceSailing?.id) : '',
		language,
		loginStatus: isAuthenticated ? 'Logged in' : 'anonymous',
		pageName: 'findacruise',
		pageType: brand.code === BRAND_RCI.code ? 'findaCruise' : 'findacruise',
		pagination: pagination?.count ? `page ${pagination?.currentPage + 1} of ${Math.ceil(results?.total / pagination?.count)}` : '',
		prodCategory: results?.cruises?.length ? results?.cruises.map(() => 'booking') : '',
		prodCost: results?.cruises?.length
			? results?.cruises.map((cruise) => Math.round(cruise.lowestPriceSailing?.lowestStateroomClassPrice?.price?.value))
			: '',
		prodQuantity: results?.cruises?.length ? results?.cruises.map(() => 1) : '',
		productEvent: results?.cruises?.length ? results?.cruises?.map(() => 'impression') : '',
		prodSku: results?.cruises?.length ? results.cruises.map((cruise) => cruise.masterSailing?.itinerary?.code) : '',
		csDepartureDate: results?.cruises?.length ? results?.cruises?.map((cruise) => cruise.lowestPriceSailing?.sailDate) : '',
		cruiseSearchPackage: ANY,
		cruiseSearchMonths: getSearchMonths(search),
		cruiseSearchPorts: departurePort || ANY,
		cruiseSearchDestCodes: destination || ANY,
		cruiseSearchNights: nights ? [`${nights[0].replace('~', '-')} Nights`] : ANY,
		cruiseSearchShipCodes: ship || ANY,
		cruiseSearchResults: results?.total,
		searchOption,
		siteSection: 'findacruise',
		promoDashboard: getFormatPromoDashboard(perks),
		splitEx,
	};

	if (trackingAction === TRACKING_ACTION.SEARCH_UPDATE) {
		trackEvent(onLoadCruiseSearchEvent);
	} else {
		trackPage(onLoadCruiseSearchEvent);
	}
}
